import React from "react";
import { Box, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";

export default function RadioCardGroup({ value, onChange, options, name, direction = "column" }) {
  const isRow = direction === "row";
  /** Descriptions make cards multi-line, so the radio tracks the title at the top. */
  const hasDescription = options.some((opt) => Boolean(opt.description));

  return (
    <RadioGroup
      value={value}
      name={name}
      onChange={onChange}
      sx={{
        display: isRow ? "grid" : "flex",
        flexDirection: isRow ? undefined : "column",
        gridTemplateColumns: isRow
          ? `repeat(${Math.max(options.length, 1)}, minmax(0, 1fr))`
          : undefined,
        gap: 1.5,
        width: "100%",
      }}
    >
      {options.map((opt) => {
        const selected = value === opt.value;
        const disabled = Boolean(opt.disabled);
        return (
          <FormControlLabel
            key={opt.value}
            value={opt.value}
            disabled={disabled}
            control={<Radio size="small" sx={{ p: 0.5, flexShrink: 0 }} />}
            label={
              <Box sx={{ flex: 1, minWidth: 0, pr: 1.25 }}>
                <Typography component="div" variant="subtitle2" fontWeight={600}>
                  {opt.title}
                </Typography>
                {opt.description && (
                  <Typography
                    variant="caption"
                    color={disabled ? "text.disabled" : "text.secondary"}
                    sx={{ display: "block", mt: 0.25 }}
                  >
                    {opt.description}
                  </Typography>
                )}
              </Box>
            }
            sx={(theme) => ({
              m: 0,
              width: "100%",
              minWidth: 0,
              display: "flex",
              flexDirection: "row-reverse",
              alignItems: isRow && hasDescription ? "flex-start" : "center",
              justifyContent: "space-between",
              boxSizing: "border-box",
              border: "2px solid",
              borderColor: selected ? "primary.main" : theme.palette.divider,
              borderRadius: 2,
              px: isRow ? 1.5 : 1.75,
              py: isRow ? 1.125 : 1.25,
              columnGap: isRow ? 1 : 1.5,
              cursor: disabled ? "not-allowed" : "pointer",
              opacity: disabled ? 0.5 : 1,
              backgroundColor: disabled ? theme.palette.action.hover : undefined,
              transition: theme.transitions.create(["border-color"], {
                duration: theme.transitions.duration.shorter,
              }),
              "&:hover": {
                borderColor: disabled || selected ? undefined : theme.palette.text.disabled,
              },
              "& .MuiFormControlLabel-label": { width: "100%", minWidth: 0, margin: 0 },
              "& .MuiButtonBase-root": { margin: 0, padding: "6px" },
            })}
          />
        );
      })}
    </RadioGroup>
  );
}
